(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ── Scroll Reveal ── */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry, idx){
        if(entry.isIntersecting){
          setTimeout(function(){
            entry.target.classList.add('cc4-visible');
          }, idx * 100);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.cc4-reveal').forEach(function(el){
      el.classList.add('cc4-visible');
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yard-sign-booking"] && !Shopify.designMode) return;
  try {
    





/* ══ FIREBASE SETUP ══ */
var FIREBASE_CONFIG = {
  apiKey: "AIzaSyDNXt4CI8hQJOTpfwIumqKcB7oG_fl1KpM",
  authDomain: "houstone-yard-greetings.firebaseapp.com",
  databaseURL: "https://houstone-yard-greetings-default-rtdb.firebaseio.com",
  projectId: "houstone-yard-greetings",
  storageBucket: "houstone-yard-greetings.firebasestorage.app",
  messagingSenderId: "161468869724",
  appId: "1:161468869724:web:424601c2f94ba90c57ca99"
};
var _fbDb=null, _fbReady=false, _fbQueue=[];
function loadFirebase(cb){
  if(_fbReady){cb(_fbDb);return;}
  _fbQueue.push(cb);
  if(_fbQueue.length>1)return;
  function loadScript(src,next){var s=document.createElement('script');s.src=src;s.onload=next;document.head.appendChild(s);}
  loadScript('https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js',function(){
    loadScript('https://www.gstatic.com/firebasejs/9.23.0/firebase-database-compat.js',function(){
      if(!firebase.apps.length)firebase.initializeApp(FIREBASE_CONFIG);
      _fbDb=firebase.database();_fbReady=true;
      _fbQueue.forEach(function(fn){fn(_fbDb);});_fbQueue=[];
    });
  });
}
function fbGetCount(date,cb){
  loadFirebase(function(db){
    db.ref('bookings/'+date+'/count').once('value')
      .then(function(s){cb(s.val()||0);}).catch(function(){cb(0);});
  });
}
function fbIncrementCount(date,cb){
  loadFirebase(function(db){
    db.ref('bookings/'+date+'/count').transaction(function(c){return(c||0)+1;})
      .then(function(r){cb(null,r.snapshot.val());}).catch(function(e){cb(e,null);});
  });
}
function fbListenCount(date,cb){
  var ref=null;
  loadFirebase(function(db){
    ref=db.ref('bookings/'+date+'/count');
    ref.on('value',function(s){cb(s.val()||0);});
  });
  return {off:function(){if(ref)ref.off();}};
}
/* ══ END FIREBASE SETUP ══ */








(function(){
'use strict';

/* ═══════════════════════════════════════════════
   GALLERY ARROWS
   ═══════════════════════════════════════════════ */
document.querySelectorAll('.pi-col-media').forEach(function(col){
  var prevBtn=col.querySelector('.pi-gallery-arrow--prev');
  var nextBtn=col.querySelector('.pi-gallery-arrow--next');
  if(!prevBtn||!nextBtn)return;
  prevBtn.setAttribute('data-hidden','true');
  nextBtn.setAttribute('data-hidden','true');
  function getSlideCount(){var items=col.querySelectorAll('.product__media-item:not(.product__media-item--variant)');if(items.length>1)return items.length;items=col.querySelectorAll('[data-media-id]');if(items.length>1)return items.length;items=col.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');if(items.length>1)return items.length;return 1;}
  function getThumbs(){var t=col.querySelectorAll('.product__media-list--thumbnails [data-thumbnail]');if(t.length)return t;t=col.querySelectorAll('.product-thumbnails li');if(t.length)return t;return[];}
  function getCurrentIdx(){var all=col.querySelectorAll('.product__media-item,[data-media-id],.swiper-slide');for(var i=0;i<all.length;i++){var el=all[i];if(el.classList.contains('is-selected')||el.getAttribute('aria-current')==='true'||el.classList.contains('swiper-slide-active'))return i;}return 0;}
  function navigate(dir){var sw=col.querySelector('.swiper');if(sw&&sw.swiper&&typeof sw.swiper.slideNext==='function'){dir>0?sw.swiper.slideNext():sw.swiper.slidePrev();return;}var thumbs=getThumbs();if(thumbs.length>1){var cur=getCurrentIdx(),next=(cur+dir+thumbs.length)%thumbs.length;var target=thumbs[next];if(target){(target.querySelector('button,a')||target).click();return;}}var active=col.querySelector('[aria-current="true"],.is-selected,.swiper-slide-active');if(active)active.dispatchEvent(new KeyboardEvent('keydown',{key:dir>0?'ArrowRight':'ArrowLeft',bubbles:true,cancelable:true}));}
  prevBtn.addEventListener('click',function(e){e.stopPropagation();navigate(-1);});
  nextBtn.addEventListener('click',function(e){e.stopPropagation();navigate(1);});
  function updateArrows(){var c=getSlideCount(),s=c>1;prevBtn.setAttribute('data-hidden',s?'false':'true');nextBtn.setAttribute('data-hidden',s?'false':'true');}
  updateArrows();setTimeout(updateArrows,300);setTimeout(updateArrows,800);
});

/* ═══════════════════════════════════════════════
   COLOR SWATCH PICKERS
   ═══════════════════════════════════════════════ */
document.querySelectorAll('.pi-swatch-row').forEach(function(row){
  var targetId=row.dataset.target;
  var hiddenInput=document.getElementById(targetId);
  var field=row.closest('.pi-field');
  var lblEl=field?field.querySelector('.pi-swatch-selected'):null;
  var errEl=field?field.querySelector('.pi-err-msg'):null;
  row.querySelectorAll('.pi-swatch').forEach(function(swatch){
    swatch.addEventListener('click',function(){
      row.querySelectorAll('.pi-swatch').forEach(function(s){s.classList.remove('pi-swatch--selected');});
      swatch.classList.add('pi-swatch--selected');
      var val=swatch.dataset.value;
      if(hiddenInput)hiddenInput.value=val;
      if(lblEl){lblEl.textContent=val;lblEl.classList.add('has-value');}
      row.classList.remove('pi-err');
      if(errEl)errEl.setAttribute('hidden','');
    });
  });
});

/* ═══════════════════════════════════════════════
   ★★★ GLOBAL REAL-TIME SLOT SYSTEM ★★★
   ─────────────────────────────────────────────
   Source of truth: Shopify /cart.js  (ALL users
   share the same store cart pool per session,
   so counting "Event Date" in active carts gives
   a real-time view of who has what date reserved)

   Additionally, confirmed (checked-out) orders are
   counted via a small localStorage cache that is
   cleared whenever the cart empties (checkout done).

   Key:  "pi_confirmed_v2" → { "2025-12-25": N, ... }
         "pi_cart_token"   → last seen cart token
   ═══════════════════════════════════════════════ */
var CONF_KEY       = 'pi_confirmed_v2';
var TOKEN_KEY      = 'pi_cart_token';
var CACHE_KEY      = 'pi_slot_cache';       /* cart counts cache, short TTL */
var CACHE_TTL_MS   = 30 * 1000;             /* 30 sec real-time cache */

/* --- Confirmed bookings (post-checkout) --- */
function loadConfirmed(){try{return JSON.parse(localStorage.getItem(CONF_KEY)||'{}');}catch(e){return{};}}
function saveConfirmed(db){try{localStorage.setItem(CONF_KEY,JSON.stringify(db));}catch(e){}}
function getConfirmedCount(date){return loadConfirmed()[date]||0;}

/* --- Cart slot cache --- */
function loadCache(){try{return JSON.parse(localStorage.getItem(CACHE_KEY)||'{}');}catch(e){return{};}}
function saveCache(db){try{localStorage.setItem(CACHE_KEY,JSON.stringify(db));}catch(e){}}

/* Increment confirmed for date when checkout detected */
function onCheckoutConfirmed(date){
  var db=loadConfirmed();
  db[date]=(db[date]||0)+1;
  saveConfirmed(db);
}

/* ─── Detect thank-you / order-status page → confirm booking ─── */
(function detectCheckout(){
  var path=window.location.pathname;
  var isThankYou=path.indexOf('/thank')>-1||
                  document.querySelector('.os-order-number,.thank-you__title,[data-order-id],.order-confirmation')!==null;
  if(isThankYou){
    var pendingDate=sessionStorage.getItem('pi_booked_date');
    if(pendingDate){
      onCheckoutConfirmed(pendingDate);
      fbIncrementCount(pendingDate, function(err){
        if(err) console.error('Firebase increment error:', err);
      });
      sessionStorage.removeItem('pi_booked_date');
    }
    return;
  }
  if(path==='/cart')return;
})();

/* ─── Count bookings for a date from live cart ─── */
/* This counts ALL items in the store's active cart for THIS browser session
   that have a matching "Event Date" property. Combined with confirmed bookings
   stored in localStorage (which persists across sessions), this gives us an
   accurate total. The cart-count represents the current user's own reservations
   and those of other open tabs/sessions sharing the cart. */
function countCartForDate(targetDate){
  var cache=loadCache();
  var cacheEntry=cache[targetDate];
  if(cacheEntry&&(Date.now()-cacheEntry.ts)<CACHE_TTL_MS){
    return Promise.resolve(cacheEntry.count);
  }
  return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){return r.ok?r.json():{items:[]};})
    .then(function(cart){
      /* Cache counts for ALL dates found in this cart response */
      var allDates={};
      (cart.items||[]).forEach(function(item){
        var props=item.properties||{};
        var d=props['Event Date']||props['event date']||props['event_date']||'';
        if(d){allDates[d]=(allDates[d]||0)+1;}
      });
      /* Update cache for all found dates */
      var now=Date.now();
      var newCache=loadCache();
      /* Clear stale entries */
      Object.keys(newCache).forEach(function(k){if(now-newCache[k].ts>CACHE_TTL_MS)delete newCache[k];});
      Object.keys(allDates).forEach(function(d){newCache[d]={count:allDates[d],ts:now};});
      /* If targetDate not in cart at all, cache as 0 */
      if(!newCache[targetDate])newCache[targetDate]={count:0,ts:now};
      saveCache(newCache);
      return allDates[targetDate]||0;
    })
    .catch(function(){return 0;});
}

/* ─── Get total slot usage from Firebase ─── */
function getSlotInfo(date, dailyLimit){
  return new Promise(function(resolve){
    fbGetCount(date, function(count){
      resolve({confirmed:count, cart:0, total:count, limit:dailyLimit});
    });
  });
}

/* US holidays auto-calc */
function _nth(n,wd,m,y){var d=new Date(y,m,1),off=(wd-d.getDay()+7)%7;return new Date(y,m,1+off+(n-1)*7);}
function _lastMon(m,y){var l=new Date(y,m+1,0);return new Date(y,m,l.getDate()-(l.getDay()+6)%7);}
function _iso(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
function usaHols(y){return[_iso(new Date(y,0,1)),_iso(_nth(3,1,0,y)),_iso(_nth(3,1,1,y)),_iso(_lastMon(4,y)),_iso(new Date(y,5,19)),_iso(new Date(y,6,4)),_iso(_nth(1,1,8,y)),_iso(_nth(2,1,9,y)),_iso(new Date(y,10,11)),_iso(_nth(4,4,10,y)),_iso(new Date(y,11,25))];}
var _cy=new Date().getFullYear();
var ALL_HOLS=usaHols(_cy).concat(usaHols(_cy+1));


/* ─── Reliable variant ID reader ─── */
function getCurrentVarId(fallback) {
  var urlParams = new URLSearchParams(window.location.search);
  var urlVar = parseInt(urlParams.get('variant'), 10);
  if (!isNaN(urlVar) && urlVar > 0) return urlVar;

  var stickyEl = document.querySelector('sticky-add-to-cart');
  if (stickyEl && stickyEl.dataset.currentVariantId) {
    var sv = parseInt(stickyEl.dataset.currentVariantId, 10);
    if (!isNaN(sv) && sv > 0) return sv;
  }

  var selectors = [
    'product-form input[name="id"]',
    'form[action*="/cart/add"] input[name="id"]',
    '.product-form input[name="id"]',
    '[data-product-form] input[name="id"]'
  ];
  for (var i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    if (el && el.value) {
      var v = parseInt(el.value, 10);
      if (!isNaN(v) && v > 0) return v;
    }
  }
  return fallback;
}

/* ═══════════════════════════════════════════════
   BOOKING FORM INSTANCES
   ═══════════════════════════════════════════════ */
document.querySelectorAll('[id^="pi-booking-"]').forEach(function(root){
  var sid=root.id.replace('pi-booking-','');
  var today=root.dataset.today;
  var sdHandle=root.dataset.sameDayHandle;
  var hlHandle=root.dataset.holidayHandle;
  var varId=parseInt(root.dataset.variantId,10);
  var isWorks=root.dataset.isWorks==='true';
  var DAILY_LIMIT=parseInt(root.dataset.dailyLimit||'6',10)||6;

  function expandDates(raw){
    if(!raw||raw==='none')return[];
    var result=[];
    raw.split(',').forEach(function(seg){
      seg=seg.trim();if(!seg||seg==='none')return;
      var rm=seg.match(/^(\d{4}-\d{2}-\d{2})\s+to\s+(\d{4}-\d{2}-\d{2})$/i)||seg.match(/^(\d{4}-\d{2}-\d{2}):(\d{4}-\d{2}-\d{2})$/);
      if(rm){var s=new Date(rm[1]+'T00:00:00'),e=new Date(rm[2]+'T00:00:00'),c=new Date(s),safe=0;while(c<=e&&safe<400){result.push(c.getFullYear()+'-'+String(c.getMonth()+1).padStart(2,'0')+'-'+String(c.getDate()).padStart(2,'0'));c.setDate(c.getDate()+1);safe++;}}
      else if(/^\d{4}-\d{2}-\d{2}$/.test(seg))result.push(seg);
    });
    return result;
  }

  var custDates=expandDates(root.dataset.holidayDates||'');
  var extraBlocked=expandDates(root.dataset.extraBlocked||'');
  var mfBlocked=expandDates(root.dataset.metafieldBlocked||'');
  var mfHolidays=expandDates(root.dataset.metafieldHolidays||'');
  var allHols=ALL_HOLS.concat(custDates).concat(mfHolidays);

  var ZIP_PRIMARY_LABEL=root.dataset.zipPrimaryLabel||'Primary Service Area';
  var ZIP_EXTENDED_LABEL=root.dataset.zipExtendedLabel||'Extended Service Area';
  var ZIP_PREMIUM_LABEL=root.dataset.zipPremiumLabel||'Premium Service Area';
  var ZIP_PRIMARY_FEE=root.dataset.zipPrimaryFee||'Free Delivery';
  var ZIP_EXTENDED_FEE=root.dataset.zipExtendedFee||'Delivery: $75';
  var ZIP_PREMIUM_FEE=root.dataset.zipPremiumFee||'Delivery: $50';

  var DELIVERY_CONFIG={};
  DELIVERY_CONFIG[ZIP_PRIMARY_LABEL]={label:ZIP_PRIMARY_FEE,badgeCls:'pi-badge--zip-ok',noteCls:'zip-ok'};
  DELIVERY_CONFIG[ZIP_EXTENDED_LABEL]={label:ZIP_EXTENDED_FEE,badgeCls:'pi-badge--zip-warn',noteCls:'zip-warn'};
  DELIVERY_CONFIG[ZIP_PREMIUM_LABEL]={label:ZIP_PREMIUM_FEE,badgeCls:'pi-badge--zip-premium',noteCls:'zip-warn'};

var ZIP_DB={};
var zipDbEl=document.getElementById('pi-zip-db-'+sid);
if(zipDbEl){try{var zd=JSON.parse(zipDbEl.textContent);Object.keys(zd).forEach(function(z){if(zd[z]&&zd[z].tier)ZIP_DB[z]={city:zd[z].city||z,tier:zd[z].tier};});}catch(e){}}
function parseZipList(raw,tier){if(!raw||raw==='none'||raw==='')return;raw.split(',').forEach(function(z){z=z.trim();if(z)ZIP_DB[z]={city:z,tier:tier};});}
parseZipList(root.dataset.zipPrimaryZips,ZIP_PRIMARY_LABEL);
parseZipList(root.dataset.zipExtendedZips,ZIP_EXTENDED_LABEL);
parseZipList(root.dataset.zipPremiumZips,ZIP_PREMIUM_LABEL);

  /* DOM refs */
  var s1=document.getElementById('pi-s1-'+sid);
  var s2=document.getElementById('pi-s2-'+sid);
  var stepEls=root.querySelectorAll('.pi-step');
  var dateInp=document.getElementById('pi-date-'+sid);
  var slotBar=document.getElementById('pi-slot-bar-'+sid);
  var slotFill=document.getElementById('pi-slot-fill-'+sid);
  var slotText=document.getElementById('pi-slot-text-'+sid);
  var noticeRegular=document.getElementById('pi-notice-regular-'+sid);
  var noticeSd=document.getElementById('pi-notice-sd-'+sid);
  var noticeHl=document.getElementById('pi-notice-hl-'+sid);
  var noticeBlocked=document.getElementById('pi-notice-blocked-'+sid);
  var noticeLimit=document.getElementById('pi-notice-limit-'+sid);
  var limitMsg=document.getElementById('pi-limit-msg-'+sid);
  var noticeLoading=document.getElementById('pi-notice-loading-'+sid);
  var zipInp=root.querySelector('.pi-zip-inp');
  var zipBadgePrimary=document.getElementById('pi-zip-primary-'+sid);
  var zipBadgeExtended=document.getElementById('pi-zip-extended-'+sid);
  var zipBadgePremium=document.getElementById('pi-zip-premium-'+sid);
  var zipBadgeOutside=document.getElementById('pi-zip-outside-'+sid);
  var zipCityPrimary=document.getElementById('pi-zip-city-primary-'+sid);
  var zipCityExtended=document.getElementById('pi-zip-city-extended-'+sid);
  var zipCityPremium=document.getElementById('pi-zip-city-premium-'+sid);
  var nextBtn=document.getElementById('pi-next-'+sid);
  var backBtn=document.getElementById('pi-back-'+sid);
  var bookBtn=document.getElementById('pi-book-'+sid);
  var rrows=document.getElementById('pi-rrows-'+sid);
  var xtraWrap=document.getElementById('pi-extra-wrap-'+sid);
  var noteWrap=document.getElementById('pi-booking-note-'+sid);
  var noteRegular2=document.getElementById('pi-note-regular-'+sid);
  var noteSd2=document.getElementById('pi-note-sd-'+sid);
  var noteHl2=document.getElementById('pi-note-hl-'+sid);
  var noteSlot=document.getElementById('pi-note-slot-'+sid);
  var noteSlotBadge=document.getElementById('pi-note-slot-badge-'+sid);
  var noteSlotText=document.getElementById('pi-note-slot-text-'+sid);
  var noteZip=document.getElementById('pi-note-zip-'+sid);
  var noteZipBadge=document.getElementById('pi-note-zip-badge-'+sid);
  var noteZipText=document.getElementById('pi-note-zip-text-'+sid);

  var _zipState=null;
  var _currentVariantPrice=null;
  var _dateBlocked=false;
  var _lastSlotInfo=null;   /* cache last fetched slot info */
  var _slotPollTimer=null;

  if(xtraWrap)xtraWrap.style.display=isWorks?'':'none';

  /* ── Variant button click → price cache bust ── */
document.querySelectorAll('.product-form__input input[type="radio"],.variant-picker input[type="radio"]').forEach(function(inp){
  inp.addEventListener('change',function(){
    /* ── varId: Horizon hidden input থেকে পড়ো ── */
    setTimeout(function(){
      var hi=document.querySelector('product-form [name="id"],form[action*="/cart/add"] [name="id"]');
      if(hi&&hi.value){var hv=parseInt(hi.value,10);if(!isNaN(hv))varId=hv;}
    },50);

    var lbl=inp.closest('label')||document.querySelector('label[for="'+inp.id+'"]');
    if(!lbl)return;
    var txt=lbl.textContent||'';
    var m=txt.match(/\$\s*([\d,]+\.?\d*)/);
    if(m){
      _currentVariantPrice=Math.round(parseFloat(m[1].replace(/,/g,''))*100);
      /* review open থাকলে live update */
      var pEl=document.getElementById('pi-review-price-'+sid);
      if(pEl)pEl.textContent='$'+(_currentVariantPrice/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    var vEl=document.getElementById('pi-review-variant-'+sid);
    if(vEl){
      var cleanV=(inp.value||lbl.dataset.value||'').replace(/\s*[-–]\s*\$[\d,.]+/g,'').trim();
      if(cleanV&&cleanV!=='Default Title'){vEl.textContent=' \u2014 '+cleanV;vEl.style.display='';}
      else{vEl.style.display='none';}
    }
  });
});
document.addEventListener('variant:changed',function(e){
    var variant=(e.detail||{}).variant||{};

    /* ── 1. Works field visibility ── */
    if(xtraWrap){
      var t=variant.title||'';
      var showW=t.toLowerCase().indexOf('work')>-1;
      xtraWrap.style.display=showW?'':'none';
      if(!showW){var i=xtraWrap.querySelector('input');if(i)i.value='';}
    }

/* ── 2. Update varId & price ── */
    if(variant.id){varId=variant.id;}
    else{varId=getCurrentVarId(varId);}
    if(variant.price!=null){_currentVariantPrice=variant.price;}
    /* ★ Double-confirm ★ */
    setTimeout(function(){
      varId=getCurrentVarId(varId);
      if(variant.price!=null){_currentVariantPrice=variant.price;}
    },100);

    /* ── Extra: Horizon fallback ── */
    if(!_currentVariantPrice||variant.price==null){
      var activeBtn=document.querySelector('.product-form__input input[type="radio"]:checked,.variant-picker input[type="radio"]:checked');
      if(activeBtn){
        var btnLabel=activeBtn.closest('label')||document.querySelector('label[for="'+activeBtn.id+'"]');
        if(btnLabel){
          var btnTxt=btnLabel.textContent||'';
          var btnPrice=btnTxt.match(/\$\s*([\d,]+\.?\d*)/);
          if(btnPrice){_currentVariantPrice=Math.round(parseFloat(btnPrice[1].replace(/,/g,''))*100);}
        }
      }
    }

    /* ── 3. Update price in review ── */
    var priceEl=document.getElementById('pi-review-price-'+sid);
    if(priceEl&&variant.price!=null){
      priceEl.textContent='$'+(variant.price/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    /* ── 4. Update variant name in review ── */
    var variantEl=document.getElementById('pi-review-variant-'+sid);
    if(variantEl){
      var cleanTitle=(variant.title||'').replace(/\s*[-–]\s*\$[\d,.]+/g,'').trim();
      if(cleanTitle&&cleanTitle!=='Default Title'){
        variantEl.textContent=' — '+cleanTitle;
        variantEl.style.display='';
      }else{
        variantEl.style.display='none';
      }
    }

    /* ── 5. ★ NEW: review panel open থাকলে varId hidden input থেকেও sync করো ── */
    if(s2&&!s2.classList.contains('pi-panel--hidden')){
      var liveHidden=document.querySelector('form[action*="/cart/add"] [name="id"],product-form [name="id"]');
      if(liveHidden&&liveHidden.value){var lhv=parseInt(liveHidden.value,10);if(!isNaN(lhv))varId=lhv;}
    }
  });


  /* ─── Slot bar UI update ─── */
  function updateSlotBar(info){
    if(!slotBar||!slotFill||!slotText)return;
    var used=info.total, limit=info.limit;
    var pct=Math.min(100,Math.round((used/limit)*100));
    var remaining=Math.max(0,limit-used);
    slotFill.style.width=pct+'%';
    if(pct>=100){
      slotFill.dataset.level='full';
      slotText.textContent='Fully booked';
      slotText.style.color='var(--danger)';
    }else if(pct>=67){
      slotFill.dataset.level='warn';
      slotText.textContent=remaining+' spot'+(remaining===1?'':'s')+' left!';
      slotText.style.color='var(--zip-warn)';
    }else{
      slotFill.dataset.level='ok';
      slotText.textContent=remaining+' spot'+(remaining===1?'':'s')+' left';
      slotText.style.color='var(--zip-ok)';
    }
    show(slotBar);
  }


  /* ─── Date notices ─── */
  function hideAllDateNotices(){
    hide(noticeRegular);hide(noticeSd);hide(noticeHl);hide(noticeBlocked);hide(noticeLimit);hide(noticeLoading);hide(slotBar);
    _dateBlocked=false;
  }

  function refreshDateNotices(val){
    hideAllDateNotices();
    if(!val)return;
    var isSame=val===today;
    var isHol=allHols.indexOf(val)>-1&&!isSame;
    var isExtraB=(extraBlocked.indexOf(val)>-1||mfBlocked.indexOf(val)>-1)&&!isSame&&!isHol;

    if(isSame){
      /* Same day — show fee notice but still check slots */
      show(noticeSd);
      /* Still fetch slot count */
      show(noticeLoading);
      getSlotInfo(val, DAILY_LIMIT).then(function(info){
        hide(noticeLoading);
        _lastSlotInfo=info;
        if(info.total>=info.limit){
          hide(noticeSd);
          if(limitMsg)limitMsg.textContent='This date is fully booked ('+info.total+'/'+info.limit+' bookings). Please choose another date or contact us.';
          show(noticeLimit);
          _dateBlocked=true;
        }else{
          updateSlotBar(info);
        }
      });
} else if (isHol) {
  show(noticeLoading);
  getSlotInfo(val, DAILY_LIMIT).then(function(info){
    hide(noticeLoading);
    _lastSlotInfo = info;
    if(info.total >= info.limit){
      if(limitMsg) limitMsg.textContent = 'This date is fully booked (' + info.total + '/' + info.limit + '). Please choose another date.';
      show(noticeLimit);
      _dateBlocked = true;
    } else {
      show(noticeHl);
      updateSlotBar(info);
      startSlotPoll(val);
    }
  });
}else if(isExtraB){
      show(noticeBlocked);_dateBlocked=true;
    }else{
      /* Normal date — fetch real-time slot count */
      show(noticeLoading);
      getSlotInfo(val, DAILY_LIMIT).then(function(info){
        hide(noticeLoading);
        _lastSlotInfo=info;
        if(info.total>=info.limit){
          if(limitMsg)limitMsg.textContent='This date is fully booked ('+info.total+'/'+info.limit+' bookings). Please choose another date or contact us.';
          show(noticeLimit);
          _dateBlocked=true;
        }else{
          show(noticeRegular);
          updateSlotBar(info);
          /* Live poll every 30s while user is on this date */
          startSlotPoll(val);
        }
      });
    }
  }

/* ── Firebase real-time listener (replaces 30s poll) ── */
var _fbListener=null;
function startSlotPoll(date){
  if(_fbListener){_fbListener.off();_fbListener=null;}
  _fbListener=fbListenCount(date,function(count){
    if(!dateInp||dateInp.value!==date)return;
    var info={confirmed:count,cart:0,total:count,limit:DAILY_LIMIT};
    _lastSlotInfo=info;
    if(count>=DAILY_LIMIT){
      hideAllDateNotices();
      if(limitMsg)limitMsg.textContent='This date just became fully booked ('+count+'/'+DAILY_LIMIT+'). Please choose another date.';
      show(noticeLimit);
      _dateBlocked=true;
    }else{
      updateSlotBar(info);
    }
  });
}

  dateInp&&dateInp.addEventListener('change',function(){
    clearInterval(_slotPollTimer);
    _lastSlotInfo=null;
    refreshDateNotices(this.value);
  });

  /* ─── ZIP ─── */
  function hideAllZipBadges(){hide(zipBadgePrimary);hide(zipBadgeExtended);hide(zipBadgePremium);hide(zipBadgeOutside);if(zipInp)zipInp.classList.remove('pi-ok','pi-err');}
  if(zipInp){
    zipInp.addEventListener('input',function(){
      this.value=this.value.replace(/[^\d]/g,'').substring(0,5);
      if(this.value.length===5){var _v=this.value;setTimeout(function(){if(zipInp.value===_v)runZipCheck(_v);},300);}
      else{_zipState=null;hideAllZipBadges();}
    });
  }
  function runZipCheck(zip){
    var info=ZIP_DB[zip];
    _zipState=info?{found:true,tier:info.tier,city:info.city||zip}:{found:false};
    hideAllZipBadges();
    if(info){
      if(info.tier===ZIP_PRIMARY_LABEL){if(zipCityPrimary)zipCityPrimary.textContent=info.city;show(zipBadgePrimary);}
      else if(info.tier===ZIP_EXTENDED_LABEL){if(zipCityExtended)zipCityExtended.textContent=info.city;show(zipBadgeExtended);}
      else if(info.tier===ZIP_PREMIUM_LABEL){if(zipCityPremium)zipCityPremium.textContent=info.city;show(zipBadgePremium);}
      if(zipInp)zipInp.classList.add('pi-ok');
    }else{show(zipBadgeOutside);if(zipInp)zipInp.classList.add('pi-err');}
  }

  /* ─── Address autocomplete (basic parse helper) ─── */
  var addrInp=root.querySelector('.pi-addr-inp');
  if(addrInp){
    addrInp.setAttribute('placeholder','e.g. 123 Main St');
    addrInp.setAttribute('autocomplete','street-address');
    addrInp.addEventListener('blur',function(){
      var val=this.value||'';
      var cityInp2=document.getElementById('pi-city-'+sid);
      if(cityInp2&&!cityInp2.value.trim()){
        var m=val.match(/,\s*([^,]+),\s*[A-Z]{2}\s+(\d{5})/);
        if(m){cityInp2.value=m[1].trim();if(zipInp&&!zipInp.value){zipInp.value=m[2];runZipCheck(m[2]);}}
      }
    });
  }

  /* ─── Step navigation ─── */
  function goStep(n){
    [s1,s2].forEach(function(p,i){if(!p)return;p.classList.toggle('pi-panel--hidden',(i+1)!==n);p.setAttribute('aria-hidden',String((i+1)!==n));});
    stepEls.forEach(function(el){var s=parseInt(el.dataset.step,10);el.classList.toggle('pi-step--active',s===n);el.classList.toggle('pi-step--done',s<n);});
    root.scrollIntoView({behavior:'smooth',block:'nearest'});
  }

nextBtn&&nextBtn.addEventListener('click',function(){

    /* ── Agreement checkbox check — FIRST ── */
    var agreeChk = document.getElementById('pi-agree-' + sid);
    var agreeErr = document.getElementById('pi-agree-err-' + sid);
    var agreeLbl = agreeChk ? agreeChk.closest('.pi-agreement') : null;
    if (agreeChk && !agreeChk.checked) {
      if (agreeLbl) agreeLbl.classList.add('pi-agree--err');
      if (agreeErr) agreeErr.removeAttribute('hidden');
      agreeChk.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (agreeLbl) agreeLbl.classList.remove('pi-agree--err');
    if (agreeErr) agreeErr.setAttribute('hidden', '');

    if(_dateBlocked){
      var dEl=document.getElementById('pi-date-'+sid);
      if(dEl){dEl.classList.add('pi-err');dEl.scrollIntoView({behavior:'smooth',block:'center'});}
      alert('The selected date is unavailable. Please choose a different date.');
      return;
    }
    /* Validate required fields */
    var fields=s1.querySelectorAll('[required]'),ok=true;
    s1.querySelectorAll('.pi-swatch-row[data-required="true"]').forEach(function(row){
      var inp=document.getElementById(row.dataset.target);
      var field=row.closest('.pi-field');
      var errEl=field?field.querySelector('.pi-err-msg'):null;
      if(inp&&!inp.value.trim()){row.classList.add('pi-err');if(errEl)errEl.removeAttribute('hidden');ok=false;}
    });
    fields.forEach(function(f){
      f.classList.remove('pi-err');
      var valid=f.type==='radio'?!!s1.querySelector('[name="'+f.name+'"]:checked'):f.value.trim()!=='';
      if(!valid){f.classList.add('pi-err');ok=false;}
      f.addEventListener('input',function(){f.classList.remove('pi-err');},{once:true});
      f.addEventListener('change',function(){f.classList.remove('pi-err');},{once:true});
    });
    if(!ok){var first=s1.querySelector('.pi-err,.pi-swatch-row.pi-err');if(first)first.scrollIntoView({behavior:'smooth',block:'center'});return;}
    buildReview();goStep(2);
  });

  /* ─── Build review panel ─── */
  function buildReview(){
    /* ── Sync latest variant price & title at moment of review build ── */
    var priceEl2=document.getElementById('pi-review-price-'+sid);
    var variantEl2=document.getElementById('pi-review-variant-'+sid);

if(priceEl2){
  /* First try: get price from Horizon's live variant data attribute */
  var liveVarInput=document.querySelector('form[action*="/cart/add"] [name="id"],product-form [name="id"]');
  var livePrice=null;
  if(liveVarInput){
    /* Horizon stores variant price in nearby data or we read from product JSON */
    var variantData=document.querySelector('[data-variant-price],[data-current-price]');
    if(variantData){
      var rawPrice=parseInt(variantData.dataset.variantPrice||variantData.dataset.currentPrice,10);
      if(!isNaN(rawPrice))livePrice=rawPrice;
    }
  }
  /* Second try: use our cached _currentVariantPrice */
  if(livePrice==null&&_currentVariantPrice!=null){livePrice=_currentVariantPrice;}
  /* Third try: read from Horizon's price DOM element */
  if(livePrice==null){
    var priceRegEl2=document.querySelector('.price__regular .price-item--regular,.price__sale .price-item--sale');
    if(priceRegEl2&&priceRegEl2.textContent.trim()){
      priceEl2.textContent=priceRegEl2.textContent.trim();
      priceRegEl2=null; /* signal done */
      livePrice=-1;
    }
  }
  if(livePrice!=null&&livePrice>=0){
    priceEl2.textContent='$'+(livePrice/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
}
    /* Read live variant title from Horizon's checked radio */
    var checkedLabel=document.querySelector('.product-form__input input[type="radio"]:checked ~ label,.variant-picker input[type="radio"]:checked ~ label');
    if(!checkedLabel){
      var checkedInput=document.querySelector('.product-form__input input[type="radio"]:checked,.variant-picker input[type="radio"]:checked');
      if(checkedInput)checkedLabel=checkedInput.closest('label')||checkedInput.parentElement;
    }
    if(variantEl2&&checkedLabel){
      var rawT=(checkedLabel.textContent||checkedLabel.dataset.value||'').trim();
  var cleanT=rawT.replace(/\s*[-–]\s*\$[\d,.]+/g,'').replace(/\s+\$[\d,.]+/g,'').trim();
      if(cleanT&&cleanT!=='Default Title'){
        variantEl2.textContent=' — '+cleanT;
        variantEl2.style.display='';
      }else{
        variantEl2.style.display='none';
      }
    }
    /* Sync varId from Horizon's hidden variant input       */
varId = getCurrentVarId(varId);

    if(rrows){

      var seen={},html='';
      s1.querySelectorAll('[name^="properties["]').forEach(function(inp){
        if(inp.type==='radio'&&!inp.checked)return;
        var key=inp.name.slice(11,-1),val=inp.value.trim();
        if(!val||seen[key])return;
        seen[key]=true;
        html+='<div class="pi-rrow"><dt>'+esc(key)+'</dt><dd>'+esc(val)+'</dd></div>';
      });
      rrows.innerHTML=html;
    }

    var dv=dateInp?dateInp.value:'';
    var isSame=dv===today;
    var isHol=allHols.indexOf(dv)>-1&&!isSame;
    var anyNote=false;

    hide(noteRegular2);hide(noteSd2);hide(noteHl2);hide(noteSlot);
    if(dv){
      if(isSame){show(noteSd2);anyNote=true;}
      else if(isHol){show(noteHl2);anyNote=true;}
      else{show(noteRegular2);anyNote=true;}
    }

    /* Show slot info in review */
    if(noteSlot&&noteSlotBadge&&noteSlotText&&_lastSlotInfo){
      var info=_lastSlotInfo;
      var remaining=Math.max(0,info.limit-info.total);
      if(info.total>=info.limit){
        noteSlotBadge.className='pi-badge pi-badge--slot-full';
        noteSlotBadge.textContent='⚠ Date fully booked';
        noteSlotText.textContent='This date is at capacity. Please go back and choose another.';
        noteSlot.className='pi-note-badge pi-note-badge--slot';
      }else if(remaining<=2){
        noteSlotBadge.className='pi-badge pi-badge--slot-warn';
        noteSlotBadge.textContent='⚡ Only '+remaining+' spot'+(remaining===1?'':'s')+' left!';
        noteSlotText.textContent='Limited availability — book now to secure your date!';
        noteSlot.className='pi-note-badge pi-note-badge--slot warn';
      }else{
        noteSlotBadge.className='pi-badge pi-badge--slot-ok';
        noteSlotBadge.textContent='✓ '+remaining+' spot'+(remaining===1?'':'s')+' left';
        noteSlotText.textContent='Limited availability — book now to secure your date!';
        noteSlot.className='pi-note-badge pi-note-badge--slot ok';
      }
      show(noteSlot);anyNote=true;
    }

    /* ZIP note */
    if(noteZip&&noteZipBadge&&noteZipText){
      if(_zipState&&_zipState.found){
        var dc=DELIVERY_CONFIG[_zipState.tier]||{label:'Delivery fee applies',badgeCls:'pi-badge--zip-warn',noteCls:'zip-warn'};
        noteZipBadge.className='pi-badge '+dc.badgeCls;
        noteZipBadge.textContent=dc.label;
        noteZipText.textContent=_zipState.city+' — '+_zipState.tier;
        noteZip.className='pi-note-badge pi-note-badge--zip '+dc.noteCls;
        show(noteZip);anyNote=true;
      }else if(_zipState&&!_zipState.found){
        noteZipBadge.className='pi-badge pi-badge--zip-outside';
        noteZipBadge.textContent='⚠ Outside Service Area';
        noteZipText.textContent='Outside standard service area — we will confirm after booking.';
        noteZip.className='pi-note-badge pi-note-badge--zip zip-warn';
        show(noteZip);anyNote=true;
      }else{hide(noteZip);}
    }

    if(noteWrap){if(anyNote)show(noteWrap);else hide(noteWrap);}
  }

  /* ═══════════════════════════════════════════════
     BOOK BUTTON — Real-time slot check before adding
     ═══════════════════════════════════════════════ */
bookBtn&&bookBtn.addEventListener('click',function(){
/* ★ Always sync varId from live hidden input first ★ */
varId = getCurrentVarId(varId);

    if(!varId||isNaN(varId)){alert('Product configuration error. Please refresh and try again.');return;}
    var dv=dateInp?dateInp.value:'';
    var isSame=dv===today;
    var isHol=allHols.indexOf(dv)>-1&&!isSame;
    var isExtraB=(extraBlocked.indexOf(dv)>-1||mfBlocked.indexOf(dv)>-1)&&!isSame&&!isHol;
    if(isExtraB || _dateBlocked){alert('This date is unavailable. Please go back and choose a different date.');return;}

    var idle=bookBtn.querySelector('.pi-btn__idle'),busy=bookBtn.querySelector('.pi-btn__busy');
    bookBtn.disabled=true;
    if(idle)idle.setAttribute('hidden','');
    if(busy)busy.removeAttribute('hidden');

    /* ★ Final slot check before committing ★ */
    /* Bust cache to get fresh count */
    var cache=loadCache();
    delete cache[dv];
    saveCache(cache);

    getSlotInfo(dv, DAILY_LIMIT).then(function(info){
      if(info.total>=info.limit){
        bookBtn.disabled=false;
        if(idle)idle.removeAttribute('hidden');
        if(busy)busy.setAttribute('hidden','');
        alert('Sorry — this date just became fully booked ('+info.total+'/'+info.limit+' bookings). Please go back and choose another date.');
        /* Refresh UI */
        hideAllDateNotices();
        if(limitMsg)limitMsg.textContent='This date is fully booked ('+info.total+'/'+info.limit+' bookings). Please choose another date.';
        show(noticeLimit);
        _dateBlocked=true;
        goStep(1);
        return;
      }

      /* Build cart items */
      var props={};
      s1.querySelectorAll('[name^="properties["]').forEach(function(inp){
        if(inp.type==='radio'&&!inp.checked)return;
        var key=inp.name.slice(11,-1),val=inp.value.trim();
        if(val)props[key]=val;
      });
      if(_zipState){
        if(_zipState.found){
          var dc=DELIVERY_CONFIG[_zipState.tier]||{label:'Delivery fee applies'};
          props['Delivery Area']=_zipState.city+' ('+_zipState.tier+')';
          props['Delivery Fee']=dc.label;
        }else{
          props['Delivery Area']='Outside standard service area — pending confirmation';
          props['Delivery Fee']='TBD';
        }
      }

      var lname=props['Name of Person']||props['Baby Name']||props['Couple Names']||'';
      var items=[{id:varId,quantity:1,properties:props}];

      Promise.resolve()
        .then(function(){
          if(isSame&&sdHandle&&sdHandle.trim()&&sdHandle!=='none'){
            return fetchVariant(sdHandle).then(function(v){if(v)items.push({id:v.id,quantity:1,properties:{'Linked Order':lname}});});
          }
        })
        .then(function(){
          if(isHol&&hlHandle&&hlHandle.trim()&&hlHandle!=='none'){
            return fetchVariant(hlHandle).then(function(v){if(v)items.push({id:v.id,quantity:1,properties:{'Linked Order':lname}});});
          }
        })
        .then(function(){
          return fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:items})
          });
        })
        .then(function(res){
          if(!res.ok){
            return res.text().then(function(txt){
              var msg='Booking failed ('+res.status+').';
              try{var j=JSON.parse(txt);msg=(j.description||j.message||msg);}catch(e){}
              throw new Error(msg);
            });
          }
          return res.json();
        })


.then(function(){
 sessionStorage.setItem('pi_booked_date', dv);
if(_fbListener){_fbListener.off();_fbListener=null;}
window.location.href='/cart';
})


        .catch(function(err){
          console.error('Booking error',err);
          bookBtn.disabled=false;
          if(idle)idle.removeAttribute('hidden');
          if(busy)busy.setAttribute('hidden','');
          alert('Something went wrong: '+(err.message||'Please try again.'));
        });
    });
  });

  function fetchVariant(handle){
    return fetch('/products/'+handle+'.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(p){return(p&&p.variants&&p.variants[0])?p.variants[0]:null;})
      .catch(function(){return null;});
  }
  function show(el){if(el)el.removeAttribute('hidden');}
  function hide(el){if(el)el.setAttribute('hidden','');}
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
});

/* ══ AGREEMENT POPUP JS ══ */
document.querySelectorAll('[id^="pi-agr-open-"]').forEach(function(openBtn){
  var sid=openBtn.id.replace('pi-agr-open-','');
  var overlay=document.getElementById('pi-agr-overlay-'+sid);
  var closeBtn=document.getElementById('pi-agr-close-'+sid);
  var acceptBtn=document.getElementById('pi-agr-accept-'+sid);
  var modalChk=document.getElementById('pi-agr-modal-chk-'+sid);
  var mainChk=document.getElementById('pi-agree-'+sid);
  var badge=document.getElementById('pi-agr-badge-'+sid);
  var status=document.getElementById('pi-agr-status-'+sid);
  var triggerBtn=document.getElementById('pi-agr-open-'+sid);

function openModal(){
  document.body.appendChild(overlay);
  overlay.removeAttribute('aria-hidden');
  overlay.setAttribute('aria-hidden','false');
  if(window.innerWidth<=600){
    overlay.style.alignItems='flex-end';
    overlay.style.padding='0';
  } else {
    overlay.style.alignItems='center';
    overlay.style.padding='20px';
  }
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      overlay.classList.add('pi-agr--open');
    });
  });
  document.body.style.overflow='hidden';
}
function closeModal(){
  overlay.classList.remove('pi-agr--open');
  overlay.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
  setTimeout(function(){
    if(overlay.parentNode===document.body){
      document.body.removeChild(overlay);
    }
  },350);
}
  openBtn.addEventListener('click',openModal);
  closeBtn&&closeBtn.addEventListener('click',closeModal);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});

  modalChk&&modalChk.addEventListener('change',function(){
    if(acceptBtn)acceptBtn.disabled=!this.checked;
  });

  acceptBtn&&acceptBtn.addEventListener('click',function(){
    if(!modalChk||!modalChk.checked)return;
    if(mainChk){mainChk.checked=true;}
    if(badge){badge.textContent='Accepted';badge.classList.add('accepted');}
    if(status){status.removeAttribute('hidden');}
    if(triggerBtn){triggerBtn.style.borderColor='rgba(52,199,89,.5)';triggerBtn.style.background='rgba(52,199,89,.06)';}
    var errEl=document.getElementById('pi-agree-err-'+sid);
    if(errEl)errEl.setAttribute('hidden','');
    closeModal();
  });
});

})();

  } catch(e) { console.error(e); }
})();
})();
